import { _ } from '../utils.js'

export default (el) => {
    const main = _('main', 'element').node()
    const footer = _('footer', 'element').node()
    const target = _(el.dataset.target, 'element').node()
    const triggerClass = el.dataset.class
    const targetClass = target.dataset.class
    el.dataset.enabled = el.dataset.enabled || 'false'
    if (el.dataset.enabled === 'true') {
        return false
    }
    el.dataset.enabled = 'true'
    el.dataset.active = false

    const closeMenu = () => {
        el.classList.remove(triggerClass)
        target.classList.remove(targetClass)
        main.removeEventListener('click', closeMenu)
        footer.removeEventListener('click', closeMenu)
    }

    const toggleClass = (e) => {
        e.preventDefault()
        const activeMenuItems = [
            ...document.querySelectorAll('.nav__item--active'),
        ]
        activeMenuItems.forEach((menuItem) =>
            menuItem.classList.remove('nav__item--active'),
        )
        el.dataset.active = el.dataset.active === 'false' ? true : false
        el.classList.toggle(triggerClass)
        target.classList.toggle(targetClass)
        if (el.dataset.active) {
            main.addEventListener('click', closeMenu)
            footer.addEventListener('click', closeMenu)
        } else {
            main.removeEventListener('click', closeMenu)
            footer.removeEventListener('click', closeMenu)
        }
    }

    el.addEventListener('click', toggleClass)
}
